/* HUMANS BEER — Shapes風アニメーション（ステッカーの回転・パララックス、年齢確認） */
(function () {
  if (window.hbShapesInit) return;
  window.hbShapesInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var INTENSITY = (50 * 109 / 100 + 1) / 100; /* Shapesのパララックス強度 50 と同じ */

  function collect() {
    return {
      rot: Array.prototype.slice.call(document.querySelectorAll('[data-hb-rotate-scroll]')),
      par: Array.prototype.slice.call(document.querySelectorAll('[data-hb-parallax]'))
    };
  }
  var items = collect();
  var ticking = false;
  function frame() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var vh = window.innerHeight;
    for (var i = 0; i < items.rot.length; i++) items.rot[i].style.transform = 'rotate(' + (y / 3) + 'deg)';
    for (var j = 0; j < items.par.length; j++) {
      var el = items.par[j];
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh * 1.2) continue;
      var speed = -1 * parseInt(el.getAttribute('data-hb-parallax') || '3', 10);
      var target = el.firstElementChild || el;
      var pct = (vh - r.top) / (vh + target.offsetHeight) - 0.5;
      var val = Math.round(INTENSITY * (speed * (pct * 100)) * 100) / 100;
      target.style.transform = 'translateY(' + val + 'px)';
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function init() { items = collect(); if (!reduce) frame(); }
  if (!reduce) {
    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  /* ヘッダーは常にハンバーガーメニュー（Shapesと同じ） */
  function forceDrawer() {
    var hc = document.querySelector('#header-component');
    if (!hc) return;
    var set = function () { if (hc.dataset.menuStyle !== 'drawer') hc.dataset.menuStyle = 'drawer'; };
    set();
    new MutationObserver(set).observe(hc, { attributes: true, attributeFilter: ['data-menu-style'] });
  }
  forceDrawer();
  document.addEventListener('DOMContentLoaded', forceDrawer);
  document.addEventListener('shopify:section:load', forceDrawer);

  /* 年齢確認 */
  var AGE_KEY = 'hb_age_check';
  function ageOk() {
    try {
      var v = JSON.parse(localStorage.getItem(AGE_KEY) || 'null');
      return v && v.exp > Date.now();
    } catch (e) { return false; }
  }
  function setupAge(root) {
    if (!root || root.dataset.hbReady) return;
    root.dataset.hbReady = '1';
    var design = window.Shopify && window.Shopify.designMode;
    if (!design && ageOk()) { root.remove(); document.documentElement.classList.remove('hb-age-lock'); return; }
    if (design) { root.hidden = true; } else { root.hidden = false; document.documentElement.classList.add('hb-age-lock'); }
    var yes = root.querySelector('[data-hb-age-yes]');
    var no = root.querySelector('[data-hb-age-no]');
    if (yes) yes.addEventListener('click', function () {
      if (!design) { try { localStorage.setItem(AGE_KEY, JSON.stringify({ exp: Date.now() + 30 * 864e5 })); } catch (e) {} }
      root.hidden = true;
      document.documentElement.classList.remove('hb-age-lock');
    });
    if (no) no.addEventListener('click', function () { window.location = root.getAttribute('data-redirect') || '/'; });
  }
  function initAge() { document.querySelectorAll('[data-hb-age]').forEach(setupAge); }
  window.hbInitAge = initAge;
  document.addEventListener('DOMContentLoaded', initAge);
  document.addEventListener('shopify:section:load', function (e) { initAge(); });
  document.addEventListener('shopify:section:select', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-hb-age]'); if (r) r.hidden = false; });
  document.addEventListener('shopify:section:deselect', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-hb-age]'); if (r) r.hidden = true; });

  /* 商品画像ギャラリー */
  function initGallery(root) {
    if (!root || root.dataset.hbReady) return;
    root.dataset.hbReady = '1';
    var track = root.querySelector('[data-hb-gal-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hb-gal-thumb]'));
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function go(i, smooth) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'instant' : 'smooth' });
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
    }
    if (current > 0) go(current, false);
    var prev = root.querySelector('[data-hb-gal-prev]');
    var next = root.querySelector('[data-hb-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-hb-gal-thumb'), 10)); }); });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var w = track.clientWidth || 1;
        var idx = Math.round(track.scrollLeft / w);
        if (idx !== current) { current = idx; slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); }); thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); }); }
      }, 80);
    }, { passive: true });
    var section = root.closest('.shopify-section');
    if (section) section.addEventListener('variant:update', function (e) {
      var v = e.detail && e.detail.resource;
      var mid = v && v.featured_media && v.featured_media.id;
      if (!mid) return;
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == mid; });
      if (idx >= 0) go(idx);
    });
  }
  function initGalleries() { document.querySelectorAll('[data-hb-gallery]').forEach(initGallery); }
  document.addEventListener('DOMContentLoaded', initGalleries);
  document.addEventListener('shopify:section:load', initGalleries);

  /* 商品カードの「カートに追加」 */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-hb-quick-buy]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name=id]').value), quantity: Number(form.querySelector('[name=quantity]').value || 1) }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (res && res.status && res.description) { alert(res.description); return; }
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'hb-quick-buy', data: { source: 'hb-quick-buy', itemCount: cart.item_count, productId: String(form.dataset.productId || '') } } }));
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') { setTimeout(function () { drawer.open(); }, 250); }
        else { window.location.href = '/cart'; }
      });
    }).catch(function () { form.submit(); }).finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* 波打つ文字（Shapesのカーブテキストと同じ計算） */
  function initCurved(root) {
    if (!root || root.dataset.hbReady) return;
    root.dataset.hbReady = '1';
    var text = root.getAttribute('data-text') || '';
    var ww = parseFloat(root.getAttribute('data-wave-width')) || 250;
    var wh = parseFloat(root.getAttribute('data-wave-height')) || 250;
    var dir = root.getAttribute('data-direction') || 'rtl';
    var speed = parseFloat(root.getAttribute('data-speed')) || 1.6;
    var animate = root.getAttribute('data-animate') === 'true';
    var path = root.querySelector('path');
    var tp = root.querySelector('textPath');
    var measure = root.querySelector('.hb-curved__measure');
    var offset = 0, total = 0, paused = false, vw = window.innerWidth;
    function build() {
      vw = window.innerWidth;
      var mid = wh / 2, start = ww * 2 * -1, seg = Math.ceil(vw * 3 / ww) + 1, p = start;
      var d = 'M' + start + ' ' + mid;
      for (var i = 0; i < seg; i++) { p += ww; d += (i === 0 ? ' Q' + (start + ww / 2) + ' ' + wh + ', ' + p + ' ' + mid : ' T' + p + ' ' + mid); }
      path.setAttribute('d', d);
      measure.textContent = text;
      var tl = measure.getBoundingClientRect().width || 1;
      var n = Math.ceil(path.getTotalLength() / tl); if (n % 2) n++;
      tp.innerHTML = '';
      for (var k = 0; k < n; k++) { var t = document.createElementNS('http://www.w3.org/2000/svg', 'tspan'); t.textContent = text; t.setAttribute('alignment-baseline', 'middle'); tp.appendChild(t); }
      total = n * tl; offset = dir === 'ltr' ? -total / 2 : 0;
    }
    function step() {
      offset += speed;
      var th = dir === 'ltr' ? 0 : total / 2;
      if (offset > th) offset = dir === 'ltr' ? -total / 2 : 0;
      tp.setAttribute('startOffset', dir === 'ltr' ? offset : -offset);
      if (!paused) requestAnimationFrame(step);
    }
    build();
    if (animate && !reduce) requestAnimationFrame(step);
    if (root.hasAttribute('data-pause-hover')) { root.addEventListener('mouseenter', function () { paused = true; }); root.addEventListener('mouseleave', function () { if (paused) { paused = false; requestAnimationFrame(step); } }); }
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (window.innerWidth !== vw) build(); }, 300); });
  }
  function initCurves() { document.querySelectorAll('[data-hb-curved]').forEach(initCurved); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(initCurves); else document.addEventListener('DOMContentLoaded', initCurves);
  document.addEventListener('shopify:section:load', initCurves);

  /* 左メニュー */
  function drawerEl() { return document.querySelector('[data-hb-drawer]'); }
  function openDrawer() {
    var d = drawerEl(); if (!d) return;
    d.hidden = false; document.documentElement.classList.add('hb-drawer-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    var c = d.querySelector('.hb-drawer__close'); if (c) c.focus();
  }
  function closeDrawer() {
    var d = drawerEl(); if (!d || d.hidden) return;
    d.classList.remove('is-open'); document.documentElement.classList.remove('hb-drawer-lock');
    setTimeout(function () { d.hidden = true; }, 300);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest && t.closest('#header-component .header__drawer, #header-component .header__icon--menu, #header-component .header-drawer summary')) { e.preventDefault(); e.stopPropagation(); openDrawer(); return; }
    if (t.closest && t.closest('[data-hb-drawer-close]')) { closeDrawer(); return; }
    var tog = t.closest && t.closest('[data-hb-drawer-toggle]');
    if (tog) { var sub = tog.nextElementSibling; var open = tog.getAttribute('aria-expanded') === 'true'; tog.setAttribute('aria-expanded', open ? 'false' : 'true'); if (sub) sub.hidden = open; }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* 6本単位の警告（Minmaxify）がカートの裏に隠れないよう、チェックアウトが止められたらカートを閉じる */
  var leaving = false;
  window.addEventListener('beforeunload', function () { leaving = true; });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-drawer .cart__checkout-button, .cart-drawer [name="checkout"]');
    if (!btn) return;
    setTimeout(function () { if (leaving) return; var d = document.querySelector('cart-drawer-component'); if (d && typeof d.close === 'function') d.close(); }, 600);
  }, true);

  /* 配送日・時間帯（カートの追加情報に保存） */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('[data-hb-dd-date], [data-hb-dd-slot]')) return;
    var box = sel.closest('[data-hb-dd]'); if (!box) return;
    var attrs = {};
    var ds = box.querySelector('[data-hb-dd-date]'), ss = box.querySelector('[data-hb-dd-slot]');
    if (ds) attrs[box.getAttribute('data-date-key')] = ds.value;
    if (ss) attrs[box.getAttribute('data-slot-key')] = ss.value;
    clearTimeout(window.__hbDdT);
    window.__hbDdT = setTimeout(function () {
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
    }, 250);
    document.querySelectorAll('[data-hb-dd] ' + (sel.matches('[data-hb-dd-date]') ? '[data-hb-dd-date]' : '[data-hb-dd-slot]')).forEach(function (o) { if (o !== sel) o.value = sel.value; });
  });
})();
